import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import { Link } from "react-router-dom";

export default function HotRevelations() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20">
      <div className="container-custom">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-fire-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-accent-500 text-sm font-semibold uppercase tracking-wider">TRENDING</span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100">
              热门爆料
            </h2>
          </div>
          <Link
            to="/category/corporate-insider"
            className="hidden sm:flex items-center gap-1 text-foreground-500 hover:text-primary-400 text-sm transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {/* First article - featured */}
          <div className="md:col-span-2 lg:col-span-2 lg:row-span-2">
            <ArticleCard article={hotArticles[0]} variant="featured" />
          </div>

          {/* Remaining articles */}
          {hotArticles.slice(1).map((article) => (
            <ArticleCard key={article.id} article={article} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}